import httpService from "@/services/httpService";

export default {
  getSubscribeUri: async () => httpService.get("/notifications/subscribe"),
  getNotifications: async (page = 1, size = 5) => httpService.get(`/notifications?page=${page}&pageSize=${size}`),
  getUnreadNotifications: async () => httpService.get("/notifications/unreadnotifications"),
  getPendingSystemNotifications: async () => httpService.get("/notifications/pendingSystemNotifications"),
  markNotificationAsRead: async notificationId =>
    httpService.post(`/notifications/markNotificationAsRead?notificationId=${notificationId}`),
};
